import { ajaxService, urlService } from "../services";
import { Response } from "../utility";

const removeDependency = () => { ajaxService.removeDependency() }

export async function getSubscribedUsers() {
    removeDependency()
    return ajaxService.get(urlService.subscribedUsers).then(response => {
        return Response(response.data);
    })
}
